export default __webpack_public_path__ + "static/media/gifta_logo.6ef4e332.jpg";